import { useLanguage } from "@/contexts/LanguageContext";
import { HorizontalTicker } from "react-infinite-ticker";
import telegramIcon from "@/assets/integrations/telegram.png";
import supabaseIcon from "@/assets/integrations/supabase.png";
import slackIcon from "@/assets/integrations/slack.png";
import shopifyIcon from "@/assets/integrations/shopify.png";
import postgresqlIcon from "@/assets/integrations/postgresql.png";
import outlookIcon from "@/assets/integrations/outlook.png";
import facebookIcon from "@/assets/integrations/facebook.png";
import gmailIcon from "@/assets/integrations/gmail.png";
import googleCalendarIcon from "@/assets/integrations/google-calendar.png";
import googleGeminiIcon from "@/assets/integrations/google-gemini.webp";
import notionIcon from "@/assets/integrations/notion.png";
import pipedriveIcon from "@/assets/integrations/pipedrive.png";
import openaiIcon from "@/assets/integrations/openai.webp";
import mysqlIcon from "@/assets/integrations/mysql-dolphin.png";
import jiraIcon from "@/assets/integrations/jira.png";
import instagramIcon from "@/assets/integrations/instagram.png";
import googleSheetsIcon from "@/assets/integrations/google-sheets.png";
import googleDriveIcon from "@/assets/integrations/google-drive.png";
import discordIcon from "@/assets/integrations/discord.png";
import githubIcon from "@/assets/integrations/github.png";

const IntegrationFlow = () => {
  const { language } = useLanguage();

  const integrations = [
    { icon: telegramIcon, name: "Telegram" },
    { icon: supabaseIcon, name: "Supabase" },
    { icon: slackIcon, name: "Slack" },
    { icon: shopifyIcon, name: "Shopify" },
    { icon: postgresqlIcon, name: "PostgreSQL" },
    { icon: outlookIcon, name: "Outlook" },
    { icon: facebookIcon, name: "Facebook" },
    { icon: gmailIcon, name: "Gmail" },
    { icon: googleCalendarIcon, name: "Google Calendar" },
    { icon: googleGeminiIcon, name: "Google Gemini" },
    { icon: notionIcon, name: "Notion" },
    { icon: pipedriveIcon, name: "Pipedrive" },
    { icon: openaiIcon, name: "OpenAI" },
    { icon: mysqlIcon, name: "MySQL" },
    { icon: jiraIcon, name: "Jira" },
    { icon: instagramIcon, name: "Instagram" },
    { icon: googleSheetsIcon, name: "Google Sheets" },
    { icon: googleDriveIcon, name: "Google Drive" },
    { icon: discordIcon, name: "Discord" },
    { icon: githubIcon, name: "GitHub" },
  ];

  const content = {
    is: {
      title: "500+ forrit. Ótakmarkaðir möguleikar."
    },
    en: {
      title: "500+ apps. Limitless integrations."
    }
  };

  const t = content[language];

  return (
    <div className="w-full bg-background py-12">
      <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-foreground">
        {t.title}
      </h2>
      
      <div className="relative overflow-hidden bg-background">
        {/* Left fade overlay */}
        <div className="absolute left-0 top-0 bottom-0 w-32 md:w-48 bg-gradient-to-r from-background to-transparent z-10 pointer-events-none" />
        
        {/* Right fade overlay */}
        <div className="absolute right-0 top-0 bottom-0 w-32 md:w-48 bg-gradient-to-l from-background to-transparent z-10 pointer-events-none" />
        
        <HorizontalTicker duration={50000}>
          {integrations.map((integration, index) => (
            <div
              key={`${integration.name}-${index}`}
              className="relative flex flex-col items-center gap-2 flex-shrink-0 mx-4 md:mx-8"
            >
              <div className="w-16 h-16 md:w-20 md:h-20 flex items-center justify-center rounded-xl bg-card border border-border p-3 overflow-hidden hover:scale-110 transition-transform duration-300">
                <img
                  src={integration.icon}
                  alt={integration.name}
                  className={`w-full h-full ${integration.name === "Google Drive" || integration.name === "Google Sheets" ? "object-contain" : "object-cover"}`}
                />
              </div>
            
              <span className="text-xs md:text-sm text-muted-foreground text-center whitespace-nowrap">
                {integration.name}
              </span>
            </div>
          ))}
        </HorizontalTicker>
      </div>
    </div>
  );
};

export default IntegrationFlow;
